import Vue from 'vue'
import Router from 'vue-router'
import Share from '@/pages/Share'
import ChannelShare from '@/pages/ChannelShare'
import ProfitDetails from '@/pages/ProfitDetails'
import FriendList from '@/pages/FriendList'
import Exchange from '@/pages/Exchange'
import ExchangeRecord from '@/pages/ExchangeRecord'
import TradingRecord from '@/pages/TradingRecord'
import DailyTask from '@/pages/DailyTask'
import DiamondDonation from '@/pages/DiamondDonation'
import DiamondDonationRecord from '@/pages/DiamondDonationRecord'
import Upload from '@/pages/Upload'
import UploadList from '@/pages/UploadList'
import Test from '@/pages/Test'
import TestDiamondDonation from '@/pages/TestDiamondDonation'
import TestDiamondDonationRecord from '@/pages/TestDiamondDonationRecord'



Vue.use(Router)

export default new Router({
  routes: [{
      path: '/Share',
      name: 'Share',
      component: Share,
      meta: {
        title: '分享'
      },
    },
    {
      path: '/ChannelShare',
      name: 'ChannelShare',
      component: ChannelShare,
      meta: {
        title: '分享'
      },
    },
    {
      path: '/ProfitDetails',
      name: 'ProfitDetails',
      component: ProfitDetails,
      meta: {
        title: '分红详情'
      },
    },
    {
      path: '/FriendList',
      name: 'FriendList',
      component: FriendList,
      meta: {
        title: '好友列表'
      },
    },
    {
      path: '/Exchange',
      name: 'Exchange',
      component: Exchange,
      meta: {
        title: '微信提现'
      },
    },
    {
      path: '/ExchangeRecord',
      name: 'ExchangeRecord',
      component: ExchangeRecord,
      meta: {
        title: '兑换记录'
      },
    },
    {
      path: '/TradingRecord',
      name: 'TradingRecord',
      component: TradingRecord,
      meta: {
        title: '交易明细'
      },
    },
    {
      path: '/DailyTask',
      name: 'DailyTask',
      component: DailyTask,
      meta: {
        title: '每日任务'
      },
    },
    {
      path: '/DiamondDonation',
      name: 'DiamondDonation',
      component: DiamondDonation,
      meta: {
        title: '钻石捐赠'
      },
    },
    {
      path: '/DiamondDonationRecord',
      name: 'DiamondDonationRecord',
      component: DiamondDonationRecord,
      meta: {
        title: '我的捐赠'
      },
    },
    {
      path: '/Upload',
      name: 'Upload',
      component: Upload,
      meta: {
        title: '上传订单'
      },
    }, {
      path: '/UploadList',
      name: 'UploadList',
      component: UploadList,
      meta: {
        title: '上传记录'
      },
    },
    {
      path: '/Test',
      name: 'Test',
      component: Test,
      meta: {
        title: '测试'
      },
    },
    {
      path: '/TestDiamondDonation',
      name: 'TestDiamondDonation',
      component: TestDiamondDonation,
      meta: {
        title: '测试钻石捐赠'
      },
    },
    {
      path: '/TestDiamondDonationRecord',
      name: 'TestDiamondDonationRecord',
      component: TestDiamondDonationRecord,
      meta: {
        title: '测试钻石明细'
      },
    }

  ]
})



// WEBPACK FOOTER //
// ./src/router/index.js